import { useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import Hero from "@/pages/home/components/Hero";
import AboutSection from "@/pages/home/components/AboutSection";
import FieldSection from "@/pages/home/components/FieldSection";
import CompareSection from "@/pages/home/components/CompareSection";
import ProcessSection from "@/pages/home/components/ProcessSection";
import SuccessSection from "@/pages/home/components/SuccessSection";
import FaqSection from "@/pages/home/components/FaqSection";
import DiagnosisSection from "@/pages/home/components/DiagnosisSection";
import CtaSection from "@/pages/home/components/CtaSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import FloatingActions from "@/pages/home/components/FloatingActions";
import ConsultModal from "@/pages/home/components/ConsultModal";

export default function Home() {
  const [consultOpen, setConsultOpen] = useState(false);
  const [consultPrefill, setConsultPrefill] = useState("");
  const openConsult = () => {
    setConsultPrefill("");
    setConsultOpen(true);
  };
  const openConsultWithMessage = (message: string) => {
    setConsultPrefill(message);
    setConsultOpen(true);
  };

  return (
    <div className="relative min-h-screen w-full bg-background-50">
      <SiteHeader onOpenConsult={openConsult} />

      <main className="relative w-full">
        <Hero onOpenConsult={openConsult} />

        <div className="relative z-10 bg-background-50">
          <AboutSection />
          <FieldSection />
          <CompareSection />
          <ProcessSection />
          <SuccessSection />
          <FaqSection />
          <DiagnosisSection
            onOpenConsult={openConsult}
            onOpenConsultWithMessage={openConsultWithMessage}
          />
          <CtaSection onOpenConsult={openConsult} />
          <SiteFooter onOpenConsult={openConsult} />
        </div>
      </main>

      <FloatingActions onOpenConsult={openConsult} />

      <ConsultModal
        open={consultOpen}
        onClose={() => setConsultOpen(false)}
        prefillMessage={consultPrefill}
      />
    </div>
  );
}